module.exports = __webpack_public_path__ + "img/FOTO_DESTILADOR.d2abbd52.jpg";